import { OfficePayrollProcessing } from "../OfficePayrollProcessing";
import { DataSource, Layout, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayrollProcessingMultiProfile extends Layout {
    layoutOfficePayrollProcessing: OfficePayrollProcessing;
    sourceOfficePayrollProfile: DataSource;
    sourceOrderPayablesCache: DataSource;
    sourcePayeeCache: DataSource;
    sourceStateFederalTaxDriverSettlement: DataSource;
    sourceVoidedPayablesOfficePayroll: DataSource;
    tabProfile: Tab;
    tabsetOfficePayrollProfiles: Tabset;
}
